import axios from "axios";
import { getReauthToken, requestReauth, clearReauthToken } from "./reauth";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.metadata = { start: performance.now() };
  const reauth = getReauthToken();
  if (reauth && !config.headers["X-Reauth"]) config.headers["X-Reauth"] = reauth;
  return config;
});

api.interceptors.response.use(
  (res) => {
    const total = Math.round(performance.now() - (res.config.metadata?.start ?? performance.now()));
    const server = parseInt(res.headers?.["x-process-time"], 10);
    window.dispatchEvent(new CustomEvent("api-timing", {
      detail: { total, server: Number.isNaN(server) ? null : server },
    }));
    return res;
  },
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const path = window.location.pathname;
    if (status === 401 && path !== "/login" && !String(error.config?.url || "").includes("/auth/reauth")) {
      clearReauthToken();
      window.location.href = "/login";
    }
    if (status === 403 && detail?.code === "REAUTH_REQUIRED" && !error.config?.__reauthRetried) {
      clearReauthToken();
      return requestReauth(detail).then((token) => {
        if (!token) return Promise.reject(error);
        error.config.__reauthRetried = true;
        error.config.headers["X-Reauth"] = token;
        return api.request(error.config);
      });
    }
    if (status === 403 && (detail === "ADMIN_GATE_REQUIRED" || detail === "ADMIN_GATE_SETUP_REQUIRED")) {
      if (sessionStorage.getItem("admin_gate_unlocked")) {
        sessionStorage.removeItem("admin_gate_unlocked");
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.code === "REAUTH_REQUIRED") return `Operação cancelada — ${detail.message}`;
  if (detail && typeof detail.message === "string") return detail.message;
  return e?.message || "Erro inesperado";
}

export default api;
